export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      agency: "L'Agence",
      apply: "Postuler",
      library: "Bibliothèque"
    },
    
    // Hero Section
    hero: {
      tagline: "Une rencontre n'est jamais un hasard",
      title: "MetaLove",
      subtitle: "L'agence qui permet aux âmes de se rencontrer",
      description: "Nous ne créons pas de rencontres. Nous révélons celles qui devaient arriver.",
      cta: "Déposer ma candidature",
      ctaSecondary: "Découvrir l'agence"
    },
    
    // Agency Page
    agency: {
      heroTitle: "L'Agence",
      heroSubtitle: "La technologie au service de l'humain",
      
      // Section Vision
      visionTitle: "Notre vision",
      visionText1: "MetaLove est née d'une conviction profonde : les vraies connexions ne se calculent pas, elles se ressentent. Mais elles peuvent être facilitées.",
      visionText2: "Nous croyons que certaines rencontres sont écrites avant même de se produire. Notre rôle est de créer les conditions pour qu'elles adviennent.",
      
      // Section Approche
      approachTitle: "Notre approche",
      approachSubtitle: "Au-delà des algorithmes",
      approachText1: "MetaLove n'est pas une application de rencontre ordinaire. Nous allons au-delà des critères superficiels — l'apparence, les centres d'intérêt communs, la proximité géographique.",
      approachText2: "Notre méthode s'appuie sur une compréhension profonde de ce qui fait qu'une relation fonctionne : les filtres de perception, les modes de communication, les besoins émotionnels fondamentaux.",
      approachText3: "La technologie nous aide à identifier les compatibilités profondes. Mais c'est une équipe humaine qui prend les décisions finales, avec empathie et discernement.",
      
      // Section Philosophie
      philosophyTitle: "Notre philosophie",
      philosophyQuote: "\"Se voir vraiment avant de se rencontrer.\"",
      philosophyText1: "Trop de relations échouent parce que les partenaires ne se sont jamais vraiment vus. Ils ont vu ce qu'ils voulaient voir, ou ce que l'autre voulait montrer.",
      philosophyText2: "Chez MetaLove, nous aidons nos membres à se comprendre eux-mêmes d'abord. À identifier leurs schémas, leurs attentes, leurs zones d'ombre. Car on ne peut trouver l'autre que si l'on s'est d'abord trouvé soi-même.",
      
      // Section Accompagnement
      supportTitle: "Un accompagnement personnalisé",
      supportText1: "Chaque candidature est étudiée avec attention. Chaque profil est unique.",
      supportText2: "Nous prenons le temps de comprendre qui vous êtes, ce que vous cherchez vraiment, et pourquoi vos relations passées n'ont peut-être pas fonctionné.",
      supportText3: "Ce n'est qu'ensuite que nous vous proposons des rencontres — peu nombreuses, mais choisies avec soin.",
      
      // CTA
      ctaTitle: "Prêt(e) à tenter l'expérience ?",
      ctaButton: "Déposer ma candidature"
    },
    
    // Apply Page (Questionnaire)
    apply: {
      title: "Votre candidature",
      subtitle: "Répondez avec sincérité. C'est le premier pas vers une rencontre authentique.",
      progress: "Question",
      of: "sur",
      next: "Continuer",
      previous: "Retour",
      submit: "Soumettre ma candidature",
      
      questions: {
        q1: {
          label: "Qu'est-ce qui vous amène ici ?",
          placeholder: "Parlez-nous de ce qui vous a conduit jusqu'à nous..."
        },
        q2: {
          label: "Comment décririez-vous votre quête ?",
          placeholder: "Décrivez ce que vous recherchez vraiment..."
        },
        q3: {
          label: "Qu'attendez-vous d'une rencontre ?",
          placeholder: "Au-delà des apparences, qu'espérez-vous découvrir ?"
        },
        q4: {
          label: "Une phrase qui vous définit",
          placeholder: "Un mot, une citation, une pensée qui résonne en vous..."
        },
        q5: {
          label: "Êtes-vous prêt(e) à faire confiance au destin ?",
          placeholder: "Pourquoi maintenant ? Pourquoi MetaLove ?"
        }
      },
      
      form: {
        firstName: "Prénom",
        firstNamePlaceholder: "Comment pouvons-nous vous appeler ?",
        email: "Email",
        emailPlaceholder: "Votre adresse email"
      },
      
      success: {
        title: "Votre candidature est entre nos mains",
        message: "Merci, {name}. Nous avons bien reçu ce que vous avez partagé avec nous.",
        note: "L'équipe MetaLove lira chacune de vos réponses avec attention. Si votre profil résonne avec notre approche, nous vous contacterons personnellement.",
        closing: "D'ici là, laissez le destin faire son chemin.",
        backHome: "Retour à l'accueil"
      },
      
      error: {
        duplicate: "Cette adresse email a déjà soumis une candidature.",
        generic: "Une erreur est survenue. Veuillez réessayer."
      }
    },
    
    // Library Page
    library: {
      title: "Bibliothèque",
      subtitle: "Les romans de l'univers MetaLove",
      seriesTitle: "Et mon Cœur a reconnu le Tien",
      seriesDescription: "Une série de romans où le destin prend une forme inattendue...",
      series2: {
        tag: "Prochainement — Nouvelle série",
        title: "Les tribulations d'une hypnothérapeute pas comme les autres",
        description: "Une série de douze romans — en cours d'écriture",
        volumeLabel: "Tome"
      },
      book1: {
        title: "RECTO — Alexandre",
        volume: "Tome 1",
        description: "Découvrez l'histoire où tout a commencé. Un roman où l'amour et le destin s'entremêlent de façon inattendue."
      },
      book2: {
        title: "VERSO — Camille",
        volume: "Tome 2"
      },
      book3: {
        title: "L'OMBRE — Zacharie",
        volume: "Tome 3"
      },
      book4: {
        title: "LA LUMIÈRE — Solène",
        volume: "Tome 4"
      },
      book5: {
        title: "PILE — Charles",
        volume: "Tome 5"
      },
      book6: {
        title: "FACE — David",
        volume: "Tome 6"
      },
      book7: {
        title: "YING — Elisa",
        volume: "Tome 7"
      },
      book8: {
        title: "YANG — Jade",
        volume: "Tome 8"
      },
      comingSoon: "À venir",
      buyButton: "Découvrir"
    },
    
    // Footer
    footer: {
      tagline: "MetaLove — L'agence qui permet aux âmes de se rencontrer",
      rights: "Tous droits réservés",
      privacy: "Confidentialité",
      terms: "Mentions légales",
      trademark: "MetaLove® est une marque déposée à l'INPI. MetaLove n'est en aucun cas affiliée à Meta Platforms, Inc."
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      agency: "The Agency",
      apply: "Apply",
      library: "Library"
    },
    
    // Hero Section
    hero: {
      tagline: "An encounter is never a coincidence",
      title: "MetaLove",
      subtitle: "The agency that allows souls to meet",
      description: "We don't create encounters. We reveal the ones that were meant to happen.",
      cta: "Submit my application",
      ctaSecondary: "Discover the agency"
    },
    
    // Agency Page
    agency: {
      heroTitle: "The Agency",
      heroSubtitle: "Technology in service of humanity",
      
      // Section Vision
      visionTitle: "Our vision",
      visionText1: "MetaLove was born from a deep conviction: true connections cannot be calculated, they are felt. But they can be facilitated.",
      visionText2: "We believe that some encounters are written before they even happen. Our role is to create the conditions for them to occur.",
      
      // Section Approche
      approachTitle: "Our approach",
      approachSubtitle: "Beyond algorithms",
      approachText1: "MetaLove is not an ordinary dating app. We go beyond superficial criteria — appearance, common interests, geographical proximity.",
      approachText2: "Our method is based on a deep understanding of what makes a relationship work: perception filters, communication modes, fundamental emotional needs.",
      approachText3: "Technology helps us identify deep compatibilities. But it's a human team that makes the final decisions, with empathy and discernment.",
      
      // Section Philosophie
      philosophyTitle: "Our philosophy",
      philosophyQuote: "\"Truly see yourself before meeting.\"",
      philosophyText1: "Too many relationships fail because partners never truly saw each other. They saw what they wanted to see, or what the other wanted to show.",
      philosophyText2: "At MetaLove, we help our members understand themselves first. To identify their patterns, their expectations, their shadow areas. Because you can only find the other if you have first found yourself.",
      
      // Section Accompagnement
      supportTitle: "Personalized guidance",
      supportText1: "Each application is carefully studied. Each profile is unique.",
      supportText2: "We take the time to understand who you are, what you're really looking for, and why your past relationships may not have worked.",
      supportText3: "Only then do we offer you encounters — few in number, but carefully chosen.",
      
      // CTA
      ctaTitle: "Ready to try the experience?",
      ctaButton: "Submit my application"
    },
    
    // Apply Page (Questionnaire)
    apply: {
      title: "Your application",
      subtitle: "Answer with sincerity. It's the first step towards an authentic encounter.",
      progress: "Question",
      of: "of",
      next: "Continue",
      previous: "Back",
      submit: "Submit my application",
      
      questions: {
        q1: {
          label: "What brings you here?",
          placeholder: "Tell us what led you to us..."
        },
        q2: {
          label: "How would you describe your quest?",
          placeholder: "Describe what you're truly looking for..."
        },
        q3: {
          label: "What do you expect from an encounter?",
          placeholder: "Beyond appearances, what do you hope to discover?"
        },
        q4: {
          label: "A sentence that defines you",
          placeholder: "A word, a quote, a thought that resonates with you..."
        },
        q5: {
          label: "Are you ready to trust fate?",
          placeholder: "Why now? Why MetaLove?"
        }
      },
      
      form: {
        firstName: "First name",
        firstNamePlaceholder: "How should we call you?",
        email: "Email",
        emailPlaceholder: "Your email address"
      },
      
      success: {
        title: "Your application is in our hands",
        message: "Thank you, {name}. We have received what you shared with us.",
        note: "The MetaLove team will read each of your answers carefully. If your profile resonates with our approach, we will contact you personally.",
        closing: "Until then, let fate take its course.",
        backHome: "Back to home"
      },
      
      error: {
        duplicate: "This email address has already submitted an application.",
        generic: "An error occurred. Please try again."
      }
    },
    
    // Library Page
    library: {
      title: "Library",
      subtitle: "Novels from the MetaLove universe",
      seriesTitle: "And My Heart Recognized Yours",
      seriesDescription: "A series of novels where fate takes an unexpected form...",
      series2: {
        tag: "Coming Soon — New Series",
        title: "The Tribulations of an Unconventional Hypnotherapist",
        description: "A series of twelve novels — in progress",
        volumeLabel: "Volume"
      },
      book1: {
        title: "RECTO — Alexandre",
        volume: "Volume 1",
        description: "Discover the story where it all began. A novel where love and fate intertwine in unexpected ways."
      },
      book2: {
        title: "VERSO — Camille",
        volume: "Volume 2"
      },
      book3: {
        title: "THE SHADOW — Zacharie",
        volume: "Volume 3"
      },
      book4: {
        title: "THE LIGHT — Solène",
        volume: "Volume 4"
      },
      book5: {
        title: "HEADS — Charles",
        volume: "Volume 5"
      },
      book6: {
        title: "TAILS — David",
        volume: "Volume 6"
      },
      book7: {
        title: "YING — Elisa",
        volume: "Volume 7"
      },
      book8: {
        title: "YANG — Jade",
        volume: "Volume 8"
      },
      comingSoon: "Coming soon",
      buyButton: "Discover"
    },
    
    // Footer
    footer: {
      tagline: "MetaLove — The agency that allows souls to meet",
      rights: "All rights reserved",
      privacy: "Privacy",
      terms: "Legal notice",
      trademark: "MetaLove® is a registered trademark. MetaLove is in no way affiliated with Meta Platforms, Inc."
    }
  }
};

export default translations;
